/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _curry = _interopRequireDefault(require("./curry"));
var _matches = _interopRequireDefault(require("../matches"));
var matches;
var _default = (0, _curry.default)(function (selector, node) {
  matches = matches || _matches.default;
  while (node = node.parentElement) {
    if (matches.call(node, selector)) {
      return node;
    }
  }
});
exports.default = _default;